import { css } from "@emotion/react";
import {
    breakpoints,
    colors,
    fontSizes,
    fontWeights,
    gutterSizes,
    mediaQuery,
} from "../base/theme";

export const infoBoxCss = css`
    &.info-box {
        position: relative;
        background: ${colors.bgInfo};
        border: none;
        border-radius: 8px;
        display: flex;
        box-sizing: border-box;
        margin-top: 18px;
        padding: 16px;
        gap: ${gutterSizes.base};

        .icon {
            font-size: ${fontSizes.xlarge};
            min-width: 20px;
        }

        .icon--info-outline {
            color: ${colors.blue};
            padding-top: 2px;
        }

        svg {
            padding-top: 2px;
            min-width: 24px;
        }

        b {
            display: block;
            font-weight: ${fontWeights.lightBold};
            margin-bottom: ${gutterSizes.small};
        }

        p {
            margin: 0;
            color: ${colors.bark};
        }

        .txt-info {
            color: ${colors.messageTextColor};
            font-weight: ${fontWeights.lightBold};
        }

        .txt-btn {
            display: block;
            padding: 0;
            margin-top: ${gutterSizes.medium};
        }

        .syi-info-box-teaser {
            ${mediaQuery.until(breakpoints.small)} {
                padding-bottom: 20px;
            }
        }

        .info-box-title {
            color: ${colors.messageTextColor};
            font-weight: ${fontWeights.lightBold};
        }
    }

    &.borderless-info-box {
        border: none;
        display: flex;
        gap: ${gutterSizes.xlarge};
        border-radius: 8px;
        background: white;
        padding: 0;

        .syi-info-box-teaser {
            color: ${colors.bark80};
            margin-bottom: ${gutterSizes.large};
        }

        ${mediaQuery.until(breakpoints.medium)} {
            gap: ${gutterSizes.large};
        }

        ${mediaQuery.until(breakpoints.small)} {
            padding-bottom: ${gutterSizes.small};
        }
    }

    &.hint-info-box {
        background-color: ${colors.surface};
    }

    &.confirmation-info-box {
        background: ${colors.green10};
    }

    .box-close-icon {
        position: absolute;
        bottom: ${gutterSizes.large};
        right: ${gutterSizes.medium};
        cursor: pointer;
    }
`;


export const alertBoxCss = (appViewDevice: boolean) => css`
    &.info-box {
        background: #FDECEA;
        padding: 16px;
        margin-bottom: ${gutterSizes.base};
        margin-top: ${gutterSizes.base};
        ${appViewDevice && css`
            margin-top: 24px;
        `}
        .icon {
            color:  #E52815;;
        }
        h4 {
            font-family: "Readex Pro";
            font-size: 15px;
            font-style: normal;
            font-weight: 600;
            line-height: 22px;
            letter-spacing: 0.15px;
            margin-bottom: ${gutterSizes.small};
        }
        p {
            font-family: "Readex Pro";
            font-size: 15px;
            font-style: normal;
            font-weight: 330;
            line-height: 22px;
            letter-spacing: 0.15px;
        }
    }
`;
